import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-navy-900 text-white py-16 md:py-24 px-4 overflow-hidden" data-id="element-62">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="space-y-8 text-center lg:text-left" data-id="element-64">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-white" data-id="element-65">
            Anti-Inflación USA:{' '}
            <span className="text-gold" data-id="element-66">
              Crea tu Tienda Digital de $0 a $1000 sin Inventario
            </span>
          </h1>
          <p className="text-lg md:text-xl text-slate-300 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-67">
            El método exacto para generar un segundo ingreso en dólares
            vendiendo soluciones simples desde tu celular, sin jefes y sin
            arriesgar tus ahorros.
          </p>
          <div className="pt-4" data-id="element-68">
            <CTAButton text="¡SÍ, QUIERO EMPEZAR MI TIENDA AHORA!" size="xl" className="w-full md:w-auto" data-id="element-69" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-70">
          <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full transform scale-90" data-id="element-71"></div>
          <img src="https://cdn.magicpatterns.com/uploads/ddUtMWJ6eUCETEAWR1xE7J/mockupmujerdigital.png" alt="Mujer latina trabajando en su tienda digital desde un iPad" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl border border-navy-800" data-id="element-72" />
        </motion.div>
      </div>
    </section>;
}